import styled from 'styled-components';

import { COLOR } from 'constants/color';

export const StepperContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StepDot = styled.div<{ active: boolean; completed: boolean }>`
  width: ${(props) => (props.completed ? '8px' : '10px')};
  height: ${(props) => (props.completed ? '8px' : '10px')};
  border-radius: 50%;
  background-color: ${(props) =>
    props.completed || props.active
      ? COLOR.primary['primary-6']
      : COLOR.neutralTrans['neutralTrans-25']};
`;

export const StepTitle = styled.span<{ active: boolean; completed: boolean }>`
  font-size: 18px;
  margin-left: -54px;
  font-weight: ${(props) => (props.active ? '600' : '400')};
  color: ${(props) =>
    props.completed || props.active ? 'rgba(0, 0, 0, 0.85)' : 'rgba(0, 0, 0, 0.45)'};
`;

export const StepLine = styled.div<{ completed: boolean }>`
  height: 4px;
  min-width: 352px;
  background-color: ${(props) => (props.completed ? COLOR.primary['primary-6'] : '#f0f0f0')};
`;

export const RowStyle = {
  gap: 4,
  alignItems: 'center',
};
